import { HANDLE } from 'constants/bounding-box';
import { WidgetType } from 'types/widget.types';
import { BOUNDING_BOX_CONFIG as IconBoundingBoxConfig } from 'widgets/IconWidget/IconWidget.config';
import { BOUNDING_BOX_CONFIG as ImageBoundingBoxConfig } from 'widgets/ImageWidget/ImageWidget.config';
import { BOUNDING_BOX_CONFIG as LineBoundingBoxConfig } from 'widgets/Lines/LineWidget/LineWidget.config';
import { BOUNDING_BOX_CONFIG as QRCodeBoundingBoxConfig } from 'widgets/QRCodeWidget/QRCodeWidget.config';
import { BOUNDING_BOX_CONFIG as StatChartBoundingBoxConfig } from 'widgets/ResponsiveWidgets/StatChartWidget/StatChartWidget.config';
// Widget specific bounding box config
import {
  TABLE_BOUNDING_BOX_CONFIG as TableBoundingBoxConfig,
  BOUNDING_BOX_CONFIG as TextBasedBoundingBoxConfig,
} from 'widgets/TextBasedWidgets/common/TextBasedWidgets.config';
import { BOUNDING_BOX_CONFIG as VideoBoundingBoxConfig } from 'widgets/VideoEmbedWidget/VideoEmbedWidget.config';

import { WidgetBoundingBoxConfig, WidgetControlDirection } from './BoundingBox.types';

// Set specific bounding box control handles for your widget
// defaults to ALL if widget is not added here
const WIDGET_BOUNDING_BOX_CONFIG: WidgetBoundingBoxConfig = {
  [WidgetType.Text]: TextBasedBoundingBoxConfig,
  [WidgetType.Icon]: IconBoundingBoxConfig,
  [WidgetType.Line]: LineBoundingBoxConfig,
  [WidgetType.Image]: ImageBoundingBoxConfig,
  [WidgetType.Table]: TableBoundingBoxConfig,
  [WidgetType.LabelText]: TextBasedBoundingBoxConfig,
  [WidgetType.StatChart]: StatChartBoundingBoxConfig,
  [WidgetType.QRCode]: QRCodeBoundingBoxConfig,
  [WidgetType.VideoEmbed]: VideoBoundingBoxConfig,
};

// By default, widgets should always scale from the corner handle if it is shown
const DEFAULT_WIDGET_BOUNDING_BOX_CONFIG: WidgetControlDirection = {
  keepAspectRatioHandles: HANDLE.CORNERS,
};

// Index for widget that is not part of a group
const NON_GROUP_MEMBER_IDX = -1;
// page scroll step when dragging widget to the edges
const PAGE_SCROLL_STEP = 20;
// page would scroll when dragging to this margin around the edges
const PAGE_SCROLL_THRESHOLD = 40;
// height breakpoint for displaying overlapping handles
const SMALL_BOUNDING_BOX_HEIGHT = 32;

export {
  WIDGET_BOUNDING_BOX_CONFIG,
  DEFAULT_WIDGET_BOUNDING_BOX_CONFIG,
  NON_GROUP_MEMBER_IDX,
  PAGE_SCROLL_STEP,
  PAGE_SCROLL_THRESHOLD,
  SMALL_BOUNDING_BOX_HEIGHT,
};
